unit login;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  WEBLib.ExtCtrls;

type
  TForm2 = class(TForm)
    WebButtonLogin: TButton;
    WebEditEmail: TEdit;
    WebPanel1: TPanel;
    WebButtonCancel: TButton;
    procedure WebButtonLoginClick(Sender: TObject);
    procedure WebButtonCancelClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  Form2: TForm2;

implementation

{$R *.dfm}

procedure TForm2.WebButtonCancelClick(Sender: TObject);
begin
     ModalResult := mrCancel;
end;

procedure TForm2.WebButtonLoginClick(Sender: TObject);
begin
     ModalResult := mrOk;
end;

procedure TForm2.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebEditEmail := TEdit.Create(Self);
  WebButtonLogin := TButton.Create(Self);
  WebButtonCancel := TButton.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebEditEmail.BeforeLoadDFMValues;
  WebButtonLogin.BeforeLoadDFMValues;
  WebButtonCancel.BeforeLoadDFMValues;
  try
    Name := 'Form2';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    FormContainer := 'fcDiv';
    ParentFont := False;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 176;
    WebPanel1.Top := 168;
    WebPanel1.Width := 289;
    WebPanel1.Height := 233;
    WebPanel1.ElementClassName := 'card';
    WebPanel1.ChildOrder := 2;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebPanel1.TabOrder := 0;
    WebEditEmail.SetParentComponent(WebPanel1);
    WebEditEmail.Name := 'WebEditEmail';
    WebEditEmail.Left := 64;
    WebEditEmail.Top := 62;
    WebEditEmail.Width := 121;
    WebEditEmail.Height := 22;
    WebEditEmail.ElementClassName := 'form-control';
    WebEditEmail.ElementFont := efCSS;
    WebEditEmail.HeightStyle := ssAuto;
    WebEditEmail.HeightPercent := 100.000000000000000000;
    WebEditEmail.Text := 'alice.bridge@demo.local';
    WebEditEmail.WidthPercent := 100.000000000000000000;
    WebButtonLogin.SetParentComponent(WebPanel1);
    WebButtonLogin.Name := 'WebButtonLogin';
    WebButtonLogin.Left := 81;
    WebButtonLogin.Top := 103;
    WebButtonLogin.Width := 96;
    WebButtonLogin.Height := 25;
    WebButtonLogin.Caption := 'Log In';
    WebButtonLogin.ChildOrder := 1;
    WebButtonLogin.ElementClassName := 'btn btn-light';
    WebButtonLogin.ElementFont := efCSS;
    WebButtonLogin.HeightStyle := ssAuto;
    WebButtonLogin.HeightPercent := 100.000000000000000000;
    WebButtonLogin.WidthPercent := 100.000000000000000000;
    SetEvent(WebButtonLogin, Self, 'OnClick', 'WebButtonLoginClick');
    WebButtonCancel.SetParentComponent(WebPanel1);
    WebButtonCancel.Name := 'WebButtonCancel';
    WebButtonCancel.Left := 81;
    WebButtonCancel.Top := 134;
    WebButtonCancel.Width := 96;
    WebButtonCancel.Height := 25;
    WebButtonCancel.Caption := 'Cancel';
    WebButtonCancel.ChildOrder := 1;
    WebButtonCancel.ElementClassName := 'btn btn-light';
    WebButtonCancel.ElementFont := efCSS;
    WebButtonCancel.HeightStyle := ssAuto;
    WebButtonCancel.HeightPercent := 100.000000000000000000;
    WebButtonCancel.WidthPercent := 100.000000000000000000;
    SetEvent(WebButtonCancel, Self, 'OnClick', 'WebButtonCancelClick');
  finally
    WebPanel1.AfterLoadDFMValues;
    WebEditEmail.AfterLoadDFMValues;
    WebButtonLogin.AfterLoadDFMValues;
    WebButtonCancel.AfterLoadDFMValues;
  end;
end;

end.